import React from 'react';

const Icon = ({ size = '29', fill = 'white', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 29 29" fill="none" {...other}>
            <mask id="a" maskUnits="userSpaceOnUse" x="0" y="0" width="29" height="29">
                <path d="M28.217 0H.177v28.04h28.04V0Z" fill={fill} />
            </mask>
            <g mask="url(#a)">
                <path
                    d="M9.524 12.267 4.851 7.594h18.693l-4.09 4.673m-9.93 0h9.93m-9.93 0 2.337-7.594h5.257l2.337 7.594m-9.93 0-.835 2.92m10.765-2.92.834 2.92M6.02 24.535l.697-2.438m16.243 2.438-.696-2.438M8.69 15.188l13.573 6.908M8.69 15.188l-1.974 6.908m15.547 0-1.974-6.908m0 0L6.716 22.096"
                    stroke={fill}
                    strokeWidth="1.869"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
};
export default React.memo(Icon);
